import * as THREE from 'three';

export class Vegetation {
  static createGrassAndFlowers(scene: THREE.Scene): void {
    for (let i = 0; i < 200; i++) {
      const x = (Math.random() > 0.5 ? 1 : -1) * (20 + Math.random() * 100);
      const z = Math.random() * 1000 - 500;
      
      // Create grass blade geometry
      const grassGeometry = new THREE.BoxGeometry(0.1, 1, 0.1);
      const grassMaterial = new THREE.MeshBasicMaterial({
        color: 0x7cfc00,
        side: THREE.DoubleSide
      });
      
      const grass = new THREE.Mesh(grassGeometry, grassMaterial);
      grass.position.set(x, 0.5, z);
      grass.rotation.z = Math.random() * Math.PI / 4 - Math.PI / 8; // Random tilt
      scene.add(grass);
      
      if (Math.random() > 0.7) {
        // Create flower stem
        const stemGeometry = new THREE.CylinderGeometry(0.05, 0.05, 1);
        const stemMaterial = new THREE.MeshBasicMaterial({ color: 0x228B22 });
        const stem = new THREE.Mesh(stemGeometry, stemMaterial);
        stem.position.set(x, 0.5, z);
        scene.add(stem);
        
        // Create tulip petals
        const petalGeometry = new THREE.ConeGeometry(0.2, 0.5, 8);
        const petalMaterial = new THREE.MeshBasicMaterial({
          color: Math.random() > 0.5 ? 0xff6347 : 0xffff00,
          side: THREE.DoubleSide
        });
        
        for (let j = 0; j < 4; j++) {
          const petal = new THREE.Mesh(petalGeometry, petalMaterial);
          petal.position.set(x, 1, z);
          petal.rotation.x = Math.PI / 2;
          petal.rotation.z = (j * Math.PI) / 2;
          scene.add(petal);
        }
        
        // Create flower center
        const centerGeometry = new THREE.SphereGeometry(0.1, 8, 8);
        const centerMaterial = new THREE.MeshBasicMaterial({ color: 0xFFD700 });
        const center = new THREE.Mesh(centerGeometry, centerMaterial);
        center.position.set(x, 1.25, z);
        scene.add(center);
      }

      if (Math.random() > 0.9) {
        // Create dandelion stem
        const dandelionStemGeometry = new THREE.CylinderGeometry(0.02, 0.02, 1);
        const dandelionStemMaterial = new THREE.MeshBasicMaterial({ color: 0x228B22 });
        const dandelionStem = new THREE.Mesh(dandelionStemGeometry, dandelionStemMaterial);
        dandelionStem.position.set(x, 0.5, z);
        scene.add(dandelionStem);

        // Create dandelion head
        const dandelionHeadGeometry = new THREE.SphereGeometry(0.2, 8, 8);
        const dandelionHeadMaterial = new THREE.MeshBasicMaterial({ color: 0xFFFFFF });
        const dandelionHead = new THREE.Mesh(dandelionHeadGeometry, dandelionHeadMaterial);
        dandelionHead.position.set(x, 1.25, z);
        scene.add(dandelionHead);
      }
    }
  }
}